import { QueryConfig } from "store/utils/query-config";

export const spamEmailsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["data.timestamp"]
  }
};
